/** @jsx jsx */
import React from 'react';
import { Box } from '@atlaskit/primitives';
import Lozenge from '@atlaskit/lozenge';
import { jsx } from '@atlaskit/css';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export const NewLozenge = () => {
	const { formatMessage } = useIntl();

	return (
		<Box as="span" paddingInlineStart="space.100">
			<Lozenge appearance="new">{formatMessage(messages.new)}</Lozenge>
		</Box>
	);
};
